import React, { FC } from 'react';
import { FetchContextProvider } from './fetchContext';
import { ResetFormContextProvider } from './resetFormContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import fr from 'date-fns/locale/fr';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FetchDataRefsContextProvider } from './FetchDataRefsContext';
import { ContractsContextProvider } from './ContractsContext';
import { I18nProvider } from '../I18nProvider';
import { BSearchFormContextProvider } from '@applications-terrains/birdz-react-library';

export type Children = {
  children?: React.ReactNode;
};

// 408 : Request Time-out
// 503 : Service Unavailable
// 504 : Gateway Time-out
const RETRYABLE_STATUS_CODES = [408, 503, 504];

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error: any) => {
        const status = error?.response?.status;
        return failureCount < 3 && RETRYABLE_STATUS_CODES.includes(status);
      }
    }
  }
});

const AppContextsProvider: FC<Children> = ({ children }) => {
  return (
    <I18nProvider>
      <LocalizationProvider adapterLocale={fr} dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <FetchContextProvider>
            <FetchDataRefsContextProvider>
              <ContractsContextProvider>
                <ResetFormContextProvider>
                  <BSearchFormContextProvider>{children}</BSearchFormContextProvider>
                </ResetFormContextProvider>
              </ContractsContextProvider>
            </FetchDataRefsContextProvider>
          </FetchContextProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
};

export default AppContextsProvider;
